import React, { memo, forwardRef } from "react";
const SvgAlphabetV = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.74 19.66c-.12.267-.253.487-.4.66-.133.173-.28.313-.44.42-.146.093-.3.153-.46.18-.16.04-.306.06-.44.06-.146 0-.3-.02-.46-.06a1.429 1.429 0 01-.46-.18 2.557 2.557 0 01-.44-.42 3.314 3.314 0 01-.38-.66l-2.92-6.82a1.78 1.78 0 01-.16-.68c0-.333.114-.607.34-.82.24-.213.534-.32.88-.32.187 0 .387.06.6.18.227.107.42.373.58.8l2.4 6.2h.04l2.46-6.22c.16-.413.347-.673.56-.78.213-.12.413-.18.6-.18.347 0 .627.107.84.32.227.213.34.473.34.78 0 .067-.013.16-.04.28-.013.107-.053.24-.12.4l-2.92 6.86z"
      />
    </svg>
  );
});
SvgAlphabetV.displayName = "SvgAlphabetV";
const MemoForwardRef = memo(SvgAlphabetV);
export default MemoForwardRef;
